import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import authService from '../../services/auth';

/**
 * PrivateRoute component for protecting routes that require authentication
 * Redirects to login page if user is not authenticated
 */
const PrivateRoute = () => {
  const isAuthenticated = authService.isLoggedIn();
  
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
